import React from 'react'
import css from './style.css'
import Modal from '../modal'
import { Grid, GridItem } from '../grid'
import JewelryPhoto from '../jewelry-photo'
import Price from '../price'
import ItemHeader from '../item-header'
import JewelryDetails from '../jewelry-details'

class JewelryModal extends Modal {
  render () {
    return (
      <Modal isOpen={this.props.isOpen} onRequestClose={this.props.onRequestClose}>
        <Grid>
          <GridItem col='1/10'>
            <span />
          </GridItem>
          <GridItem col='8/10'>
            <Grid>
              <GridItem col='1/2'>
                <JewelryPhoto small />
              </GridItem>
              <GridItem col='1/2'>
                <ItemHeader type='jewelry' data={this.props.modalRow} />
                <Price price={this.props.price} styleClass={css.price} />
              </GridItem>
            </Grid>
            <JewelryDetails data={this.props.modalRow} additionalNotes={this.props.modalRow.additionalNotes} />
          </GridItem>
          <GridItem col='1/10'>
            <span />
          </GridItem>
        </Grid>
      </Modal>
    )
  }
}

export default JewelryModal



// WEBPACK FOOTER //
// ./src/components/jewelry-modal/index.js